import React from 'react';
import sortArrowDownward from '../../assets/icons/sort-arrow-downward.svg';
import sortArrowUpward from '../../assets/icons/sort-arrow-upward.svg';
import swapVert from '../../assets/icons/swap-vert.svg';
import { SortIconImg, SortIconWrapper } from './styles';

/** Matches DataTable / react-bootstrap-table caretRender sort icons (swap-vert + arrows). */
export const TableSortIcon = ({ order }) => {
  const isActive = order === 'asc' || order === 'desc';
  const src =
    order === 'asc' ? sortArrowUpward : order === 'desc' ? sortArrowDownward : swapVert;

  return (
    <SortIconWrapper aria-hidden="true">
      <SortIconImg src={src} alt="" $active={isActive} />
    </SortIconWrapper>
  );
};

/** For react-bootstrap-table TableHeaderColumn caretRender prop. */
export const renderTableSortCaret = (order) => <TableSortIcon order={order} />;
